// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-i_cY"};